$(document).ready(function() {
	if(!document.querySelector('.support-carousel')) return false;
	var supportCarousel = {
		$el : $('.support-carousel'),
		init : function() {
			this.$el.find('.carousel-wrap.type-hero').each(function() {
				if($(this).find('.carousel-box').length>1) {
					supportCarousel.runSlick($(this));
				} else {
					$(this).addClass('active');
				}
			});
			this.$el.find('.carousel-wrap.type-etc').each(function() {
				$(this).addClass('active');
			});
			this.addAriaDescribedby();
		},
		runSlick: function($obj) {
			var fontColor = 'black';
			if($obj.find('.carousel-box').eq(0).find('.text-area').hasClass('text-white')) {
				fontColor = 'white';
			}
			$obj.slick({
				infinite: false, // WA-GPC0055-01
				listStyle: true, // WA-GPC0055-01
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows : true,
				dots: true,
				//adaptiveHeight: true,
				// lazyLoad: 'ondemand',
				autoplay: true,
				autoplaySpeed: 8000,
				prevArrow: carouselOptions.bigAnglePrev, // common.js variable
				nextArrow: carouselOptions.bigAngleNext, // common.js variable
				appendDots:$obj.next().find('.slick-dot-wrap')
			});
			$obj.addClass('active');
			$obj.addClass('slick-'+fontColor);
			$obj.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				$obj.find('.carousel-box[data-slick-index='+nextSlide+'] .visual-area img[data-src]').addClass('lazyload');
			});
			$obj.on('afterChange', function(event, slick, currentSlide){
				if($obj.find('.slick-current .text-area').hasClass('text-white')) {
					fontColor = 'white';
				} else {
					fontColor = 'black';
				}
				$obj.removeClass('slick-white').removeClass('slick-black').addClass('slick-'+fontColor);
			});
			$obj.next().find('.slide-pause').addClass('active').on('click',function(e){
				e.preventDefault();
				if ($(this).hasClass('pause')) {
					$(this).removeClass('pause').addClass('play');
					$(this).text($(this).attr('data-title-play'));
					$obj.slick('slickPause');
				} else {
					$(this).removeClass('play').addClass('pause');
					$(this).text($(this).attr('data-title-stop'));
					$obj.slick('slickPlay');
				}
			});
			// $obj.find('.slide-pause').trigger('click');
		},
		addAriaDescribedby: function(){
			var _this = supportCarousel;
			var waNumber = 0;
			$(_this.$el).find('.text-area').each(function() {
				var $target;
				if($(this).find('.title') && !$(this).find('.title').is(':empty')) {
					$target = $(this).find('.title');
				}
				if($target) {
					$target.attr('id', 'supportHome_'+waNumber);
					$(this).find('a.btn').attr('aria-describedby', 'supportHome_'+waNumber);
					$(this).find('a.link-text').attr('aria-describedby', 'supportHome_'+waNumber);
					waNumber++;
				}
			});
		}
	};
	supportCarousel.init();
	
	// search box common script
	var searchCommon = [],
		searchInit = function () {
			$('.search-common-hero').each(function (idx) {
				var $searchCommon = $(this);
				if ($searchCommon.data('searchIdx') == undefined) {
					idx = searchCommon.length;

					this.setAttribute('data-search-idx', idx);
					searchCommon[idx] = {
						//$obj : $(document.querySelector('.search-common')),
						$obj: $searchCommon,
						canFocus: 0,
						canSubmit: 0,
						canCookie: 0,
						minLength: 0,
						cookieName: '',
						action: '',
						max: 10,
						functionName: '',
						$layer: null,
						$input: null,
						$recentArea: null,
						$resultArea: null,
						$template: null,
						$btnSubmit: '',
						$btnClose: '',
						init: function () {
							var el = this.$obj;
							this.canFocus = el.data('canfocus');
							this.canSubmit = el.data('cansubmit');
							this.cookieName = el.data('cookiename');
							this.functionName = el.data('function');
							this.minLength = el.data('minlength') ? el.data('minlength') : 1;
							this.$layer = supportCarousel.$el.find('.support-search-content');
							this.$input = el.find('.search-common-input');
							this.$recentArea = this.$layer.find('.recent-suggested-type');
							this.$resultArea = this.$layer.find('.search-result-list');
							this.$template = this.$layer.find('template');
							this.action = el.attr('action');
							this.max = el.data('max');
							this.$btnSubmit = el.find('input.submit');
							this.$btnClose = supportCarousel.$el.find('.support-search-content').find('.link-close');
							if (this.cookieName) {
								this.canCookie = 1;
							}
							// Recent, Focus and Input must be run when layer exists
							if (this.$layer.length > 0) {
								this.bindInput();
								if (this.canFocus > 0) {
									this.bindFocus();
								} else {
									// hide see more
									this.$resultArea.find('.search-result-seemore').hide();
									this.bindNoFocus();
								}
								// If layer exists in mobile, float to top in focus
								/*
								if ('ontouchstart' in window) {
									this.$input.on('focus', function() {
										//searchCommon[idx].$obj.addClass('fixed');
										$('body').addClass('floating-search');
									});
									// close
									this.$input.on('blur', function() {
										searchCommon[idx].$obj.removeClass('fixed');
										$('body').removeClass('band-scroll');
									});
								}
								*/
								// Find all focusable children

								var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';

								//if(!$('.navigation').hasClass('mobile-device')) { // do not remove 'if', because android bug
									// 20200406 START 박지영 || search input에서 키보드 포커스 처리 수정 [redmine #5487]
									/*
									this.$input.on('blur', function(e) {
										e.preventDefault();
										var close = $(this).closest('.search-common').find('.search-layer .predictive-search:visible').find('.search-footer-area a.link-close');
										if(close && close.length>0) {
											close.focus();
										}
									});
									*/
									this.$input.on('keydown', function(e){
										if (e.keyCode === 9) {
											if (e.shiftKey) {
												supportCarousel.$el.find('.support-search-content').removeClass('active');												
											}
										}
									});
									this.$btnSubmit.on('keydown', function(e){
										if ((e.which === 9 && !e.shiftKey)) {
											if(searchCommon[idx].$layer.hasClass('active')){
												e.preventDefault();
												var focusObj = supportCarousel.$el.find('.support-search-content').find('a[href]:visible, area[href]:visible, button:not([disabled]), *[tabindex], *[contenteditable]');
												focusObj.first().focus();
											}											
										}
									});
									// 20200406 END
								//}

								this.$layer.on({
									keydown: function(e){
										// Convert NodeList to Array
										var focusableElements = e.currentTarget.querySelectorAll(focusableElementsString);
										focusableElements = Array.prototype.slice.call(focusableElements);
										var firstTabStop = focusableElements[0];
										var lastTabStop = focusableElements[focusableElements.length - 1];
										// Check for TAB key press
										if (e.keyCode === 9) {
											// SHIFT + TAB
											if (e.shiftKey) {
												if (document.activeElement === firstTabStop) {
													e.preventDefault();
													lastTabStop.focus();
												}
											// TAB
											} else {
												if (document.activeElement === lastTabStop) {
													e.preventDefault();
													/* LGECI-258 20201221 add */
													// Suggested Searches - 1st item.focus() 삭제, close 클릭 기능과 동일하게 focus out + search-common-input으로 focus
													if(searchCommon[idx].$btnSubmit.length>0) searchCommon[idx].$input.focus();
													var thisLayer = searchCommon[idx].$layer;
													setTimeout(function() {
														thisLayer.removeClass('active');
													}, 100);
													/* //LGECI-258 20201221 add */
												}
											}
										}
										// ESCAPE
										if (e.keyCode === 27) {
											closeModal();
										}
									}
								}, '.predictive-search');
							}
							this.$btnClose.on('click', function (e) {
								e.preventDefault();
								// 20200525 START 박지영 : IE에서 close 클릭시 닫기가 잘 안되는 버그 수정
								// 20200406 START 박지영 || close 버튼 선택시 입력단으로 focus 수정 [redmine #5487]
								if(searchCommon[idx].$btnSubmit.length>0) searchCommon[idx].$input.focus();
								// 20200406 END
								var thisLayer = searchCommon[idx].$layer;
								setTimeout(function() {
									thisLayer.removeClass('active');
									if(supportCarousel.$el.find('.carousel-wrap.type-hero').next().find('.slide-pause').hasClass('pause')){
										supportCarousel.$el.find('.carousel-wrap.type-hero').slick('slickPlay');
									}
								}, 100);
								// 20200525 END
							});

							// Submit
							this.bindSubmit();

							// Close search layer
							$('body').on('click touchend', function (event) {
								if (!$(event.target).parents('.search-area')[0]) {
									searchCommon[idx].$layer.removeClass('active');
									if(supportCarousel.$el.find('.carousel-wrap.type-hero').next().find('.slide-pause').hasClass('pause')){
										supportCarousel.$el.find('.carousel-wrap.type-hero').slick('slickPlay');
									}
								}
							});
							// Close the search layer when blur event occurs at the end of the search layer
							this.$recentArea.find('ul.list:last-child li:last-child a').on('blur', function () {
								searchCommon[idx].$layer.removeClass('active');
							});
							this.$resultArea.find('.search-result-seemore a').on('blur', function () {
								searchCommon[idx].$layer.removeClass('active');
							});

							// init
							this.$input.data('oldtext', ''); // for ie11 bug
						},
						bindNoFocus: function () {
							if($('.search-model-result').length>0) {
								// manuals and documents, software and drivers page only
								this.$input.on('focus', function (e) {
									e.preventDefault();
									if (!searchCommon[idx].$layer.hasClass('active')) {
										searchCommon[idx].$layer.addClass('active');
									}
								});
							}
						},
						bindFocus: function () {
							this.$input.on('focus', function (e) {
								e.preventDefault();
								// check the cookie
								var recentCookieTxt;
								var recentCookieArr;
								if (this.canCookie == 1) {
									recentCookieTxt = getCookie(searchCommon[idx].cookieName);
									if (recentCookieTxt == undefined) recentCookieTxt = '';
									recentCookieArr = recentCookieTxt.split('|');
									if (recentCookieTxt == '') {
										removeCookie(searchCommon[idx].cookieName);
									}
								}
								// open the layer
								if (!searchCommon[idx].$layer.hasClass('active')) {
									searchCommon[idx].$layer.addClass('active');
									supportCarousel.$el.find('.carousel-wrap.type-hero').slick('slickPause');
								}
								searchCommon[idx].doRecent();
								supportCarousel.$el.find('.carousel-wrap.type-hero').slick('slickGoTo', 0, true);
							});
						},
						bindInput: function () {
							this.$input.on('input', function (e) {
								// check the cookie
								var recentCookieTxt;
								var recentCookieArr;
								if (this.canCookie == 1) {
									recentCookieTxt = getCookie(searchCommon[idx].cookieName);
									recentCookieArr = recentCookieTxt.split('|');
									if (recentCookieTxt == '') {
										removeCookie(searchCommon[idx].cookieName);
									}
								}
								// check the input's value
								if (searchCommon[idx].$input.val() == '' && (searchCommon[idx].$input.data('oldtext') != searchCommon[idx].$input.val())) {
									searchCommon[idx].doRecent();
									// open the layer
									if (!searchCommon[idx].$layer.hasClass('active')) {
										searchCommon[idx].$layer.addClass('active');
									}
								} else if (searchCommon[idx].minLength <= searchCommon[idx].$input.val().length) {
									searchCommon[idx].doResult();
									// open the layer
									if (!searchCommon[idx].$layer.hasClass('active')) {
										searchCommon[idx].$layer.addClass('active');
									}
								}
								searchCommon[idx].$input.data('oldtext', searchCommon[idx].$input.val());
							});
							// REQ-022 : 스크립트 추가 시작
							this.$input.on('focus', function(e) {
								if(searchCommon[idx].$input.closest('.GPC0009').length>0) {
									searchCommon[idx].doResult();
									// open the layer
									if (!searchCommon[idx].$layer.hasClass('active')) {
										searchCommon[idx].$layer.addClass('active');
									}
								}
							});
							// REQ-022 : 스크립트 추가 끝
						},
						bindSubmit: function () {
							this.$btnSubmit.on('click', function (e) {
								e.preventDefault();
								if ($(this).closest('.parts-accessories').length > 0) {
									// for parts & accessories
									adobeTrackEvent('parts-accessories-search', {
										search_keyword: $(this).siblings('.search-common-input').val(),
										search_type: "support:parts_accessories",
										page_event: {onsite_search: true}
									});
								}
								searchCommon[idx].doSubmit();
							});
						},
						bindClickKeyword: function () {
							searchCommon[idx].$recentArea.find('ul.list li a').not('.delete').off('click', '**').on('click', function (e) {
								e.preventDefault();
								// Adding a value to the search input and Submit Form
								var searchTxt = xssfilter($(this).find('.product-name').text(), 'form');
								searchCommon[idx].$input.val(searchTxt);
								searchCommon[idx].doSubmit();
							});
						},
						bindDeleteKeyword: function () {
							searchCommon[idx].$recentArea.find('ul.list li a.delete').off('click', '**').on('click', function (e) {
								e.preventDefault();
								var searchTxt = xssfilter($(this).parent().find('.product-name').text(), 'form'),
									recentNoResult = searchCommon[idx].$recentArea.find('.not-result.recent-keyword'),
									recentList = searchCommon[idx].$recentArea.find('ul.list.recent-keyword');
								//console.log('test1');
								if (searchCommon[idx].canCookie == 1) {
									//console.log('test2');
									searchCommon[idx].deleteCookieList(searchTxt);
								}
								// Remove this in the list
								$(this).closest('li').remove();
								if (searchCommon[idx].$recentArea.find('ul.list.recent-keyword li').length <= 0) {
									recentNoResult.show();
									recentList.empty().hide();
								}
							});
						},
						doSubmit: function (noRefresh) {
							var searchTxt = xssfilter(this.$input.val(), 'form');
							this.$input.val(searchTxt);
							if (!this.$obj.is('.auto-validation-form')) {
								if ($.trim(searchTxt) != '') {
									if (this.canCookie == 1) this.addCookieList(searchTxt);
									var noSubmitArea = this.$resultArea.find('.no-submit');
									if (this.canSubmit == 1 && noRefresh != true) {
										if($('.resource-search-form-wrap').length>0 && $('.results-summary').length>0) {
											// CS Help Library, CS Video Tutorials
											adobeTrackEvent('cs-onsite-search', {search_keyword : searchCommon[idx].$obj.find('.search-input input[type=text]').val(), page_event : {onsite_search : true}});
										}
										this.$obj.submit();
									} else {
										noSubmitArea.show();
										if($('.search-model-result').length>0) {
											// manuals and documents, software and drivers page only
											if (this.canFocus <= 0) {
												if (!searchCommon[idx].$layer.hasClass('active')) {
													searchCommon[idx].$layer.addClass('active');
												}
											}
										}
										return false;
									}
								} else {
									return false;
								}
							} else {
								this.$obj.submit();
							}
						},
						doResult: function () {
							this.$resultArea.show();
							this.$recentArea.hide();
							var noSubmitArea = this.$resultArea.find('.no-submit'),
								url = this.$input.data('predictive-url'),
								searchTxt = {};

							if(this.$resultArea.closest('.GPC0009').length>0) {
								searchTxt.searchModel = xssfilter(this.$input.val(), 'form');
								searchTxt.modelId=this.$obj.find('input[name=modelId]').val();
							} else {
								searchTxt.search = xssfilter(this.$input.val(), 'form');
							}

							noSubmitArea.hide();
							// ajax call
							ajax.call(url, searchTxt, 'json', function (data, _this) {
								if(data.data) {
									searchCommon[idx].ajaxSuccess(data.data[0], _this);
								} else {
									searchCommon[idx].ajaxSuccess(data, _this);
								}
							});
						},
						doRecent: function () {
							if (this.canFocus == 1) this.$recentArea.show();
							this.$resultArea.hide();
							// check the cookie
							if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
								var recentCookieTxt;
								var recentCookieArr;
								if (this.canCookie == 1) {
									recentCookieTxt = getCookie(this.cookieName);
									if (recentCookieTxt == undefined) recentCookieTxt = '';
									recentCookieArr = recentCookieTxt.split('|');
									if (recentCookieTxt == '') {
										removeCookie(this.cookieName);
									}
									var recentNoResult = searchCommon[idx].$recentArea.find('.not-result.recent-keyword'),
										recentList = searchCommon[idx].$recentArea.find('ul.list.recent-keyword');
									//console.log(recentCookieArr);
									if (recentCookieTxt == 'undefined' || recentCookieTxt == '') {
										recentNoResult.show();
										recentList.empty().hide();
									} else {
										if (recentCookieTxt == '') {
											recentNoResult.show();
											recentList.empty().hide();
										} else {
											var list = '';
											for (var i = 0; i < recentCookieArr.length; i++) {
												list = list + '<li><a href="#"><strong class="product-name">' + recentCookieArr[i] + '</strong></a><a href="#" class="delete"><span class="icon"></span><span class="sr-only">Delete</span></a></li>';
											}
											recentNoResult.hide();
											recentList.html(list).show();
											this.bindDeleteKeyword();
										}
									}
									this.bindClickKeyword();
									// show recent head
									this.$recentArea.find('.search-head').eq(0).show();
								} else {
									searchCommon[idx].$recentArea.find('.not-result.recent-keyword').hide();
									searchCommon[idx].$recentArea.find('ul.list.recent-keyword').empty().hide();
									// hide recent head
									this.$recentArea.find('.search-head').eq(0).hide();
								}
							} else {
								var $obj = this.$recentArea.find('ul.list.recent-keyword');
								$obj.siblings('.not-result.recent-keyword').hide();
								ePrivacyCookies.view('load', 'small', $obj);
							}
						},
						addCookieList: function (searchTxt) {
							// add searchTxt in cookie list
							var recentCookieTxt = getCookie(this.cookieName);
							if (recentCookieTxt == undefined) recentCookieTxt = '';
							var recentCookieArr = recentCookieTxt.split('|');

							// Clear duplicate values on array
							var isDup = recentCookieArr.indexOf(searchTxt);
							if (isDup > -1) recentCookieArr.splice(isDup, 1);

							// If you have five search terms, delete the oldest one.
							if(recentCookieArr.length>=5) {
								recentCookieArr.pop();
							}

							// Add new value to the front of the array
							if (recentCookieTxt == 'undefined' || recentCookieTxt == '') recentCookieArr = [searchTxt];
							else recentCookieArr.unshift(searchTxt);

							// set Cookie
							if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
								setCookie(this.cookieName, recentCookieArr.join('|'));
							}
						},
						deleteCookieList: function (searchTxt) {
							// delete searchTxt in cookie list
							var recentCookieTxt = getCookie(this.cookieName);
							if (recentCookieTxt == undefined) recentCookieTxt = '';
							var recentCookieArr = recentCookieTxt.split('|');
							// delete searchTxt from array
							var isTxt = recentCookieArr.indexOf(searchTxt);
							if (isTxt > -1) recentCookieArr.splice(isTxt, 1);

							// set Cookie
							if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
								if (recentCookieArr.length > 0) {
									setCookie(this.cookieName, recentCookieArr.join('|'));
								} else {
									removeCookie(this.cookieName);
								}
							} else {
								removeCookie(this.cookieName);
							}
						},
						ajaxSuccess: function (data, _this) {
							var seemore = searchCommon[idx].$resultArea.find('.search-result-seemore');
							if (!data.link || data.link == '') {
								seemore.hide();
							} else {
								seemore.show().find('a').attr('href', data.link);
							}

							var recentNoResult = searchCommon[idx].$resultArea.find('.not-result'),
								resultList = searchCommon[idx].$resultArea.find('ul.list');
							
							if (data.Flag == 'N') {
								recentNoResult.show();
								resultList.hide();
							} else {
								recentNoResult.hide();
								resultList.show();
								var len = data.predictive ? data.predictive.length : '';
								html = '';
								if (len > 0) {
									if (len > this.max) len = this.max;

									if (this.$template[0] != undefined) {
										var template = this.$template;
										this.$template.find('script').remove();
										for (var j = 0; j < len; j++) {
											var _templateMarkup = template.clone().html();

											_templateMarkup = _templateMarkup.replace('*url*', data.predictive[j].url)
												.replace('*model*', data.predictive[j].model)
												.replace('*name*', data.predictive[j].name)
												.replace('*category*', data.predictive[j].category);

											html = html + (_templateMarkup);
										}

									} else {
										for (var i = 0; i < len; i++) {

											var tempCateHTML = '';
											if(data.predictive[i].cate) tempCateHTML = tempCateHTML + ' data-category='+data.predictive[i].cate;
											else if(data.predictive[i].cs_category_id) tempCateHTML = tempCateHTML + ' data-category='+data.predictive[i].cs_category_id;
											if(data.predictive[i].subcate) tempCateHTML = tempCateHTML + ' data-subcategory='+data.predictive[i].subcate;
											else if(data.predictive[i].cs_sub_category_id) tempCateHTML = tempCateHTML + ' data-subcategory='+data.predictive[i].cs_sub_category_id;

											if (data.predictive[i].model && !data.helpModelFlag) { // model search 

												//LGEJP-52 ADD
												if(COUNTRY_CODE.toLowerCase() == 'jp'){// <span class="product-name"></span> 제거
													html = html + '<li><a rel="nofollow" href="' + data.predictive[i].url + '"'+tempCateHTML+'><span class="model-name">' + data.predictive[i].model + '</span><span class="category-name">' + data.predictive[i].category + '</span></a></li>';
												} else{
													html = html + '<li><a rel="nofollow" href="' + data.predictive[i].url + '"'+tempCateHTML+'><span class="model-name">' + data.predictive[i].model + '</span><span class="product-name">' + data.predictive[i].name + '</span><span class="category-name">' + data.predictive[i].category + '</span></a></li>';
												}
											}
											else if(data.helpModelFlag){ // <span class="model-name"></span> 제거
												html = html + '<li><a rel="nofollow" href="' + data.predictive[i].url + '"'+tempCateHTML+'><span class="product-name">' + data.predictive[i].name + '</span><span class="category-name">' + data.predictive[i].category + '</span></a></li>'; //LGEBR-126

											}
											else if(data.helpModelFlag){ // <span class="model-name"></span> 제거
												html = html + '<li><a rel="nofollow" href="' + data.predictive[i].url + '"'+tempCateHTML+'><span class="product-name">' + data.predictive[i].name + '</span><span class="category-name">' + data.predictive[i].category + '</span></a></li>'; //LGEBR-126
											}
											else {
												html = html + '<li><a rel="nofollow" href="' + data.predictive[i].url + '"'+tempCateHTML+'><span class="model-name">' + data.predictive[i].content + '</span><span class="product-name">' + data.predictive[i].name + '</span><span class="category-name">' + data.predictive[i].category + '</span></a></li>';
											}
										}
									}
									resultList.html(html);
									if (this.functionName && this.functionName != '') {
										resultList.find('li a').on('click', function (e) {
											e.preventDefault();
											var model = $(this).find('.model-name').text();
											var category = $(this).data('category');
											var subcategory = $(this).data('subcategory');
											var functionNameText = searchCommon[idx].functionName;
											if(functionNameText) {
												if(functionNameText=="pickerBox.model") {
													// CS Software & Drivers, CS Manuals & Documents
													new Function(functionNameText + '("' + model + '", "'+category+'", "'+subcategory+'")')(); // jshint ignore:line
													$(this).closest('form.search-common-hero').find('.search-input input[type=text]').val($(this).find('.model-name').text());
													// CS Software & Drivers, CS Manuals & Documents : Search
													adobeTrackEvent('cs-onsite-search', {search_keyword : searchCommon[idx].$obj.find('.search-input input[type=text]').val(), page_event : {onsite_search : true}});
												} else {
													new Function(functionNameText + '()')(); // jshint ignore:line
												}
											}
											searchCommon[idx].$layer.removeClass('active');
										});
									}
									var $resultValue = searchCommon[idx].$layer.find('.results .value');
									if ($resultValue.length > 0) {
										$resultValue.text(data.predictive.length);
									}
								} else {
									recentNoResult.show();
									resultList.hide();
									var $resultValue1 = searchCommon[idx].$layer.find('.results .value');
									if ($resultValue1.length > 0) {
										$resultValue1.text('0');
									}
								}
							}
						}
					};
					searchCommon[idx].init();
				}
			});
		};
	(function ($) {
		if (!document.querySelector('.search-common-hero')) return false;
		searchInit();
	})(jQuery);
	
	$('body').on('click.seemorehero','.search-area .search-layer .search-footer-area a.link-more-hero', function(e) {
		e.preventDefault();
		var url = $(this).attr('href');
		var searchTxt = $('.search-common-hero').find('.search-input input').val();
		$form = $("<form />", {id: 'tmpForm', action:url, method: 'post'});
		$form.append('<input type="hidden" name="search" value="'+xssfilter(searchTxt)+'">');
		$('body').append($form);
		$("#tmpForm").submit();
	});
});
